import { render, staticRenderFns } from "./ReviewListContentUnit.vue?vue&type=template&id=606e0bf4&scoped=true&"
import script from "./ReviewListContentUnit.vue?vue&type=script&lang=js&"
export * from "./ReviewListContentUnit.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListContentUnit.vue?vue&type=style&index=0&id=606e0bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e0bf4",
  null
  
)

export default component.exports